import React, {useEffect} from 'react'
import {useFormContext} from 'react-hook-form'
import {Button, ButtonWrapper} from '../../../../../components/UI/Button'
import {useLavanderia} from '../../../../../hooks/useLavanderia'
import {TabLavanderiaModel} from '../../../../../models'
interface Props {
  loading?: boolean
  generateTicket?: () => void
  deleteClick?: () => void
  textComponentGo?: string
  textComponentBack?: string
  reception?: () => void
  option?: string
}
const ActionsContent = ({
  loading,
  generateTicket,
  deleteClick,
  reception,
  textComponentGo = '',
  textComponentBack = '',
  option = '',
}: Props) => {
  const {currentTabItem, changeCurrentTabItem, isAllowed} = useLavanderia()
  const {reset} = useFormContext()
  const handleShowNewForm = () => {
    const obj: TabLavanderiaModel = {
      ...currentTabItem,
      showPanel: false,
      idToEdit: '',
      idToDelete: '',
      isNew: true,
      content: {
        headerPanel: textComponentGo,
      },
      aditionalInformation: {
        ...currentTabItem.aditionalInformation,
        order: {
          isView: false,
        },
      },
    }
    changeCurrentTabItem(obj)
    reset()
  }
  const handleBack = () => {
    const obj: TabLavanderiaModel = {
      ...currentTabItem,
      content: {
        headerPanel: textComponentBack,
      },
    }
    reset()
    changeCurrentTabItem(obj)
  }

  const handleRestText = () => {
    reset()
    const obj: TabLavanderiaModel = {
      ...currentTabItem,
      reset: true,
    }
    changeCurrentTabItem(obj)
  }

  let getDisabledDelete = currentTabItem.laundrySelected?.length !== 1 ? true : false
  let getDisableGenerateTicket = currentTabItem.laundrySelected?.length !== 1 ? true : false
  let getDisableReception = currentTabItem.laundrySelected?.length === 0 ? true : false

  return (
    <ButtonWrapper>
      {currentTabItem.content.headerPanel === textComponentBack && isAllowed('NUEVO') && (
        <Button label='Nuevo' onClick={handleShowNewForm} />
      )}
      {option !== 'appOrder' &&
        (currentTabItem.content.headerPanel === textComponentGo || currentTabItem.showPanel) && (
          <Button typeBtn='submit' label='Guardar' loading={loading} disabled={loading} />
        )}
      {option !== 'appOrder' && currentTabItem.content.headerPanel === textComponentGo && (
        <Button label='Limpiar' onClick={() => handleRestText()} />
      )}
      {isAllowed('ELIMINAR') && (
        <Button label='Eliminar' disabled={getDisabledDelete} onClick={deleteClick} />
      )}
      {option === 'order' && (
        <Button
          label='Generar ticket'
          disabled={getDisableGenerateTicket}
          onClick={generateTicket}
        />
      )}
      {option === 'order' && (
        <Button label='Recepción' disabled={getDisableReception} onClick={reception} />
      )}
      {currentTabItem.content.headerPanel === textComponentGo && (
        <Button label='Volver al listado' classNameProp='ms-auto' onClick={handleBack} />
      )}
    </ButtonWrapper>
  )
}

export default ActionsContent
